module.exports = __webpack_public_path__ + "img/Trust-waratah-colour-small.7fd66c9b.png";